import React from 'react';

const Eye = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" {...props}>
      <path
        d="M8.66667 12.5C12.3486 12.5 15.3333 8.5 15.3333 8.5C15.3333 8.5 12.3486 4.5 8.66667 4.5C4.98477 4.5 2 8.5 2 8.5C2 8.5 4.98477 12.5 8.66667 12.5Z"
        stroke="currentColor"
        stroke-linejoin="round"
      />
      <path
        d="M8.66667 10.1666C9.58713 10.1666 10.3333 9.42039 10.3333 8.49992C10.3333 7.57945 9.58713 6.83325 8.66667 6.83325C7.7462 6.83325 7 7.57945 7 8.49992C7 9.42039 7.7462 10.1666 8.66667 10.1666Z"
        stroke="currentColor"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Eye;
